/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
// import axios from 'axios';
import $http from '../plugins/axios';

// const BASE_URL = 'http://localhost:3000/local/genome-solidify-api-svc/';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const getLearnerStatus = async (url: string, learnerTaskIid: string) => {
  // let res;
  // // eslint-disable-next-line camelcase
  // await $http.get(`${url}/${learnerTaskIid}`).then((response) => {
  //   // console.log(response.data.sys_settings);
  //   res = response.data;
  //   return res;
  // });
  // return res;
  const res = await $http.get(`${url}/${learnerTaskIid}`);
  return res;
};

const saveFeedback = async (url: string, feedbackData: any) => {
  // let res;
  // await $http.post(url, feedbackData).then((response) => {
  //   console.log('axios response', response);
  //   res = response.data;
  //   return res;
  // });
  // return res;
  const res = await $http.post(url, feedbackData);
  return res;
};

export { getLearnerStatus, saveFeedback };
